import React from "react"
import withHooks from "../../Common/jsx/WithHooks"
import { strToUpperSnakeCase } from "../../Common/js/string_utils"
import ResponseTypesList from "./ResponseTypesList"
import ResponseTypeForm from "./ResponseTypeForm"

class ResponseTypesManager extends React.Component {
  constructor(props) {
    super(props)

    this.dMgr = this.props.DebugManager(this.constructor.name)
    // this.dMgr.activate(true)
    this.dMgr.debug("const_props:", this.props)

    this.entityType = "responseType"
    this.entitiesType = this.entityType + "s"

    this.state = {
      pageType: this.props.pageType,
    }
    this.dMgr.debug("init_state:", this.state)
  }

  render() {
    this.dMgr.rendering()

    let toRender
    if (this.state.pageType === "list") {
      this.dMgr.debug("toRender:", "list")

      if (!this.props.RightsManager.userHasRight(strToUpperSnakeCase(this.entityType) + ":VIEW_COLLECTION")) {
        console.log("ACCESS DENIED TO " + this.entityType)
        window.location = "/"
        return null
      }

      toRender = <ResponseTypesList entityType={this.entityType} entitiesType={this.entitiesType} goTo={(pageName) => this.setState({ pageType: pageName })} />
    } else if (this.state.pageType === "form") {
      this.dMgr.debug("toRender:", "form", "entityId:", this.props.entityId)

      if (!this.props.RightsManager.userHasRight(strToUpperSnakeCase(this.entityType) + ":EDIT")) {
        console.log("ACCESS DENIED TO " + this.entityType)
        window.location = "/"
        return null
      }

      toRender = <ResponseTypeForm entityType={this.entityType} entitiesType={this.entitiesType} goTo={(pageName) => this.setState({ pageType: pageName })} entityId={this.props.entityId} />
    }

    this.dMgr.renderDone()
    return toRender
  }
}

export default withHooks(ResponseTypesManager)
